<template>
  <h1 class="section-heading-large">{{heading}}</h1>
</template>

<script>
export default {
  name: 'SectionHeadingLarge',
  props: {
    heading: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.section-heading-large {
  color: #fff;
  font-size: 48px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 568px) {
    font-size: 30px;
    padding-bottom: 10px;
  }
}
</style>


